import * as React from "react";

import { ErrorBoundary } from "lib/error-boundary";
import { lazilyLoadedComponent } from "lib/react-lazy-loading";
import type { WireRenderer } from "webapp/wire-renderers/wire-renderer";
import "twin.macro";
import type { WireRichTextComponent } from "common/generator/components/fluent-components";
import { isDefined } from "common/Support";

const MarkdownView = lazilyLoadedComponent("markdown-view", () => import("../markdown/markdown-view"));

export const WireRichText: WireRenderer<WireRichTextComponent> = React.memo(p => {
    const { text } = p;
    if (!isDefined(text)) return null;
    return (
        <ErrorBoundary>
            <React.Suspense fallback={<div />}>
                <MarkdownView markdown={text} tw="p-6! bg-bg-front rounded-lg shadow-md" />
            </React.Suspense>
        </ErrorBoundary>
    );
});
